import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { DividerModule } from '@openng/optimus-ui/divider';

import { fb, routeParams } from '../../../../../modules/shared/shared.global-service';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { VatCodeObject } from '@libs/types/src/mado/object-type/organization';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { OrganizationSettingsVatCodeDialogStore } from './organization-settings-vat-code-dialog.store';
import { vatCodeMutationFrag } from './organization-settings-vat-code-dialog.query';
import { SwitchInputComponent } from '../../../../kit/input/switch-input/switch-input.component';
import { NumberInputComponent } from '../../../../kit/input/text-input/number-input.component';

@Component({
    selector: 'app-organization-settings-vat-code-dialog',
    templateUrl: './organization-settings-vat-code-dialog.component.html',
    providers: [OrganizationSettingsVatCodeDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DividerModule,
        TextInputComponent,
        SwitchInputComponent,
        NumberInputComponent,
    ],
})
export class OrganizationSettingsVatCodeDialogComponent extends BaseDialogComponent {
    protected readonly store = inject(OrganizationSettingsVatCodeDialogStore);

    protected readonly data = this.dialogConfig.data.vatCode || null;

    protected form = fb.group({
        id: fb.control<number | null>(null),
        name: fb.control<string | null>(null, [Validators.required]),
        code: fb.control<string | null>(null),
        amount: fb.control<number | null>(null, [Validators.required]),
        included: fb.control<boolean | null>(null),
    });

    protected readonly prefix = 'organization-settings.mado.vatCode.';

    constructor() {
        super();

        this.patchForm(this.data);
    }

    override async save() {
        if (isInvalid(this.form)) return;

        const data = {
            name: this.form.value.name!,
            code: this.form.value.code!,
            amount: Number(this.form.value.amount!),
            included: !!this.form.value.included!,
        };

        if (this.form.value.id) {
            await this.store.api.updateVatCode(
                {
                    id: this.form.value.id,
                    ...data,
                },
                vatCodeMutationFrag,
            );
            contentGlobalSuccess.next('common.updated');
            this.dialogRef.close(true);

        } else if (routeParams.organizationId()) {
            await this.store.api.createVatCode(
                {
                    organizationId: Number(routeParams.organizationId()),
                    ...data,
                },
                vatCodeMutationFrag,
            );
            contentGlobalSuccess.next('common.created');
            this.dialogRef.close(true);
        }
    }

    private patchForm(item: VatCodeObject | null) {
        if (item) {
            this.form.patchValue({
                id: item.id,
                name: item.name,
                code: item.code,
                amount: item.amount,
                included: item.included,
            });
        }
    }
}
